import { render, staticRenderFns } from "./NewMessage.vue?vue&type=template&id=7487022d&scoped=true"
import script from "./NewMessage.vue?vue&type=script&lang=js"
export * from "./NewMessage.vue?vue&type=script&lang=js"
import style0 from "./NewMessage.vue?vue&type=style&index=0&id=7487022d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7487022d",
  null
  
)

export default component.exports